import { gql } from '@apollo/client';

export const getCanjeComercioCDNI = gql`
query CanjeComercioCDNIApi{
    canjeComercioCDNI(cuit:$cuit)  
    @rest(type: "canjeComercioCDNI", path: "/gateway/cdni-beneficios/buscadores/{args.cuit}"){
        linkPromo1
        linkPromo2
        web
        tituloFormulario
        subtituloFormulario
        botonPromo1
        botonPromo2
    }
}
`